import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { SearchFilterSpec } from '../models/search-filter-spec.model';

/** Behind one method so a future LLM parser can be swapped in via this token with zero
    changes downstream. `Observable` (not a bare array) from day one is what makes that
    swap possible: a Phase-2 async parser needs no interface change. */
export interface ISearchParser {
  parse(query: string): Observable<SearchFilterSpec[]>;
}

export const SEARCH_PARSER = new InjectionToken<ISearchParser>('SEARCH_PARSER');
